import { useBranch } from '../contexts/BranchContext';

// แจ้งเตือนตอนเลือก "รวมทุกสาขา" ค้างไว้ — หน้าส่วนใหญ่ (เมนู/สต๊อก/ตั้งค่า/โต๊ะ ฯลฯ)
// ต้องการสาขาเดียวชัดเจนถึงจะใช้งานได้ ไม่งั้นจะเห็นแค่ error ใน console เงียบๆ
// โดยไม่รู้สาเหตุ (หน้ารายงาน/แดชบอร์ดที่รองรับ "รวมทุกสาขา" จริงๆ ไม่ได้รับผลกระทบ
// เพราะยังใช้งานได้ปกติ แบนเนอร์นี้แค่เตือนเผื่อไว้)
export default function AllBranchesBanner() {
  const { isAllBranches } = useBranch();
  if (!isAllBranches) return null;

  return (
    <div style={{
      background: 'linear-gradient(135deg, #fef3c7 0%, #fde68a 100%)',
      color: '#854d0e',
      padding: '10px 20px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      gap: '10px',
      fontSize: '14px',
      fontWeight: '600',
      textAlign: 'center'
    }}>
      <span>⚠️</span>
      <span>กำลังดู "รวมทุกสาขา" — บางหน้า (เมนู, สต๊อก, ตั้งค่าเครื่องพิมพ์/ราคา ฯลฯ) ต้องเลือกสาขาที่แน่นอนจากเมนูด้านซ้ายก่อนถึงจะใช้งานได้</span>
    </div>
  );
}
